import { dialog, InputJson, toDisplayCase } from "../../../../nq-component";
import { getObjectUseCase, upsertUseCase } from "../../../../usecases/object";
import withRouter from "../../../../withRouter";
import BaseFormPage from "../../../../base/BaseFormPage";
import NavBar from "../../../../components/navbar";
import FormFactory from "../../../../components/FormFactory";
import DialogModal from "../../../../components/Dialog";
import ComponentsFormPresenter from "./PullOutFormPresenter";
import BreakdownTable from "../../../../components/BreakdownTable";
import ComponentDetails from "./components/ComponentDetails";

class PullOutFormPage extends BaseFormPage {
  constructor(props) {
    super(props);
    this.state = {
      object: {},
      advanced: false,
      selectedRawIds: [],
      componentBaseQty: null,
      base_raw_materials: [],
    };
    this.presenter = new ComponentsFormPresenter(
      this,
      getObjectUseCase(),
      upsertUseCase(),
    );
  }

  getCollectionName() {
    return "backup_pullouts";
  }

  onClickAdvance() {
    this.setState({ advanced: !this.state.advanced });
  }

  onSubmitForm(e) {
    e.preventDefault();

    dialog.fire({
      html: (
        <DialogModal
          icon="bi bi-question-octagon-fill"
          iconColor="#82c14a"
          title="Confirm to Proceed"
          message="Are you sure want to continue this action?"
          isCancelButton={true}
          onSubmit={() => this.presenter.submit()}
          onClose={() => dialog.close()}
        />
      ),
      footer: false,
    });
  }

  async onChange(value, field) {
    this.presenter.onChange(value, field);
  }

  handleOpenRaw() {}

  handleDeleteSelected() {}

  handleSelectAll = (e) => {};

  handleSelectOne = (e, id) => {};

  handleChangeQuantity = (e, index) => {};

  render() {
    const object = this.state.object;
    const advanced = this.state.advanced;
    const schema = this.getSchema(this.getCollectionName());

    if (!schema) return <h1>no schema</h1>;
    const label = this.getObjectId() === undefined ? "Add " : "View ";
    return (
      <>
        <NavBar />
        <div className="overflow-auto">
          <div className="h-100">
            <div className="p-3 p-lg-4">
              <h2
                className="fw-bold mt-3 text-capitalize"
                style={{ color: "#82c14a" }}
              >
                <i
                  onClick={() => this.navigateBack()}
                  class="bi bi-chevron-compact-left"
                  style={{ color: "black" }}
                ></i>
                {label +
                  (schema.label || toDisplayCase(this.getCollectionName()))}
              </h2>
              <div
                className="mt-2 shadow rounded p-3 px-lg-5 py-lg-4"
                style={{ backgroundColor: "#f6f5fa" }}
              >
                {!object?.id && (
                  <>
                    <h6>Details</h6>
                    <hr />
                  </>
                )}

                <form onSubmit={this.onSubmitForm.bind(this)}>
                  <div className="row g-3">
                    {advanced ? (
                      <InputJson
                        defaultValue={object}
                        onChange={this.onChange.bind(this)}
                        rows="15"
                      />
                    ) : (
                      <>
                        {object?.id ? (
                          <ComponentDetails object={object} />
                        ) : (
                          <FormFactory
                            key={object.componentId || "new"}
                            schema={schema}
                            object={object}
                            onChange={this.onChange.bind(this)}
                            excludeFields={["rawMaterials", "cost", "itemName"]}
                          />
                        )}
                      </>
                    )}
                  </div>

                  <BreakdownTable
                    title="Raw Materials Breakdown"
                    data={
                      object?.id
                        ? object.rawMaterials
                        : object.raw_materials || []
                    }
                    selectedIds={this.state.selectedRawIds}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onChange={this.handleChangeQuantity}
                    onAdd={() => this.handleOpenRaw()}
                    onDelete={() => this.handleDeleteSelected()}
                    disableAdd={!this.state.hasQuantity && !this.getObjectId()}
                    hasQuantity={this.state.hasQuantity || !!this.getObjectId()}
                    showUOM={true}
                    showSKU={false}
                    showAddButton={false}
                    // disableQty={true}
                    checkbox={false}
                  />

                  <BreakdownTable
                    title="Sub-Component Breakdown"
                    data={object.otherComponents || []}
                    selectedIds={this.state.selectedRawIds}
                    onSelectAll={this.handleSelectAll}
                    onSelectOne={this.handleSelectOne}
                    onChange={this.handleChangeQuantityComponent}
                    onAdd={() => this.handleOpenComponent()}
                    onDelete={() => this.handleDeleteSelected()}
                    disableAdd={!this.state.hasQuantity && !this.getObjectId()}
                    hasQuantity={this.state.hasQuantity || !!this.getObjectId()}
                    showUOM={true}
                  />

                  {object?.id ? (
                    <div className="mt-4 text-center">
                      <button
                        type="button"
                        className="btn btn-sm fs-sm text-white w-25"
                        onClick={this.onClickBack.bind(this)}
                        style={{ backgroundColor: "#82c14a" }}
                      >
                        Back
                      </button>
                    </div>
                  ) : (
                    <div className="mt-4 text-center">
                      <button
                        type="button"
                        className="btn fs-sm "
                        onClick={this.onClickBack.bind(this)}
                        style={{ backgroundColor: "#d1d1d1" }}
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn fs-sm text-white ms-3"
                        style={{ backgroundColor: "#82c14a" }}
                      >
                        <i className="bi text-white bi-file-earmark-check me-2"></i>
                        Submit
                      </button>
                    </div>
                  )}
                </form>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  }
}

export default withRouter(PullOutFormPage);
